import { render, staticRenderFns } from "./StandardFullIcon.vue?vue&type=template&id=a75f1524"
import script from "./StandardFullIcon.vue?vue&type=script&lang=js"
export * from "./StandardFullIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports